import { ITemplateStylingSettings } from '@/components/settings-page/platformSettings/templatesSettings/types';
import { IFieldEditor } from '@/shared/types/fieldEditor';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { DefaultTheme } from 'styled-components/dist/types';
import { formatAiFieldValueForTemplate, formatFieldValueForTemplate, truncateString } from '../../../utils';
import { templateStyles } from '../../style';
import { splitTermsThreeColumns } from '../../utils';
import { PDFMagicWandIcon } from '../PDFMagicWandIcon';

const fontStyles = {
  'Roboto Slab': 'normal',
  Oswald: 'normal',
  Pacifico: 'normal'
};

interface ThreeColumnSectionProps {
  fields: IFieldEditor[];
  templateStylingData: ITemplateStylingSettings;
  includeAiSuggested: boolean;
  theme: DefaultTheme;
}

export const ThreeColumnSection = ({ fields, templateStylingData, includeAiSuggested, theme }: ThreeColumnSectionProps) => {
  const styles = StyleSheet.create({
    termField: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      fontSize: '9px',
      fontFamily: 'Open Sans',
      color: theme.font.base,
      fontWeight: 600
    },
    termFieldName: {
      fontWeight: 700
    },
    blankTermField: {
      fontStyle: '600italic'
    }
  });

  return (
    <View style={{ marginBottom: '30px' }}>
      <View style={templateStyles.termSectionWrap}>
        {splitTermsThreeColumns(fields).map((fields, index) => (
          <View key={index} style={templateStyles.termFieldsWrap}>
            {fields.map((field) => (
              <View key={field.id} wrap={false} style={styles.termField}>
                <Text style={styles.termFieldName}>
                  {field.value === null && field.commentary === null && field.AI?.answers.length && includeAiSuggested
                    ? `* ${field.name}`
                    : field.name}
                  :
                </Text>
                {field.value === null && field.commentary === null && field.AI?.answers.length && includeAiSuggested ? (
                  <>
                    {field.AI?.answers.length && includeAiSuggested ? (
                      <Text>{truncateString(formatAiFieldValueForTemplate(field.documentFieldType, field.AI.answers[0]), 250)}</Text>
                    ) : (
                      <Text style={styles.blankTermField}> Not specified</Text>
                    )}
                  </>
                ) : (
                  <Text> {truncateString(formatFieldValueForTemplate(field.documentFieldType, field.value, field.commentary), 250)}</Text>
                )}
              </View>
            ))}
          </View>
        ))}
      </View>
      {fields.filter((field) => (!field.value || field.value === field.AI?.answers[0]) && field.AI?.answers.length).length && includeAiSuggested ? (
        <View style={{ ...templateStyles.aiIconWrap, color: theme.font.weak }}>
          <View style={{ borderRight: `1px solid ${theme.border.base}`, paddingRight: '3px' }}>
            <PDFMagicWandIcon fill={theme.font.weak} />
          </View>
          <Text style={{ margin: '2px 0 0 5px' }}>{fields.length > 1 ? '* These fields are AI Suggested' : 'This field is AI Suggested'}</Text>
        </View>
      ) : null}
    </View>
  );
};
